(function () {
  'use strict';

  function initCarousel(section) {
    if (!section || section.dataset.rouxMediaCarouselReady === 'true') return;
    section.dataset.rouxMediaCarouselReady = 'true';

    var slides = Array.from(section.querySelectorAll('[data-rmc-slide]'));
    var dots = Array.from(section.querySelectorAll('[data-rmc-dot]'));
    var prev = section.querySelector('[data-rmc-prev]');
    var next = section.querySelector('[data-rmc-next]');
    var track = section.querySelector('[data-rmc-track]');
    var index = 0;
    var autoplay = section.dataset.autoplay === 'true';
    var autoplaySeconds = Math.max(3, Number(section.dataset.autoplaySeconds || 6));
    var timer = null;
    var touchStartX = null;

    if (!slides.length) return;

    function pauseInactiveVideos() {
      slides.forEach(function (slide, slideIndex) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (slideIndex === index) {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      });
    }

    function showSlide(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      pauseInactiveVideos();
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplay || slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      timer = window.setInterval(function () {
        showSlide(index + 1);
      }, autoplaySeconds * 1000);
    }

    function restartTimer() {
      if (!autoplay) return;
      startTimer();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        showSlide(index - 1);
        restartTimer();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(index + 1);
        restartTimer();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(Number(dot.dataset.index || 0));
        restartTimer();
      });
    });

    if (track) {
      track.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;

        var diff = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(diff) < 42) return;

        showSlide(index + (diff < 0 ? 1 : -1));
        restartTimer();
      }, { passive: true });

      track.addEventListener('mouseenter', stopTimer);
      track.addEventListener('mouseleave', startTimer);
      track.addEventListener('focusin', stopTimer);
      track.addEventListener('focusout', startTimer);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    showSlide(0);
    startTimer();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-media-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
